import { Component, Input, OnInit, ViewContainerRef, ViewEncapsulation } from '@angular/core';

import { ESRI } from '../../../../esri-loader-util';
import { FillStyleOptions, LineStyleOptionsForArcServer, LineStyleOptionsWithNull } from '../../../../selectionOptions';
import { LayerService } from '../../../../services/layer.service';
import { PrintService } from '../../../../services/print.service';
import { FillStyle, LineStyle } from '../../../../types';
import { BaseSymbolEditorComponent } from '../baseSymbolEditor';

let Color: __esri.ColorConstructor;

@Component({
    encapsulation: ViewEncapsulation.ShadowDom,
    selector: 'mc-polygon-symbol-editor-ng',
    templateUrl: './polygon-symbol-editor.component.html',
    styleUrls: ['../../../sharedStyles/base.scss', './polygon-symbol-editor.component.scss']
})
export class PolygonSymbolEditorComponent extends BaseSymbolEditorComponent implements OnInit {

    polygonSymbol: __esri.SimpleFillSymbol;
    fillStyle: FillStyle;

    outlineStyle: LineStyle;
    outlineWidth: number;
    lineStyleOptions = LineStyleOptionsWithNull;
    fillStyleOptions = FillStyleOptions;
    showBackgroundColorPicker = false;
    showOutlineColorPicker = false;

    get isLineStyleSupportedForPrinting(): boolean {
        return this.printService.validateServerSideLayerStyle(this.outlineStyle);
    }

    get replacementLineStyle(): string {
        return this.printService.getSupportedLineStyle(this.outlineStyle);
    }

    async ngOnInit() {
        Color = await ESRI.Color;
    }

    @Input() set layerType(val: string) {
        if (val === 'map-image' || val === 'dynamic') {
            this.lineStyleOptions = LineStyleOptionsForArcServer;
        } else {
            this.lineStyleOptions = LineStyleOptionsWithNull;
        }
    }

    constructor(
        _vcr: ViewContainerRef,
        private readonly printService: PrintService,
        protected readonly layerService: LayerService) {
            super(_vcr, layerService);
    }

    bindForm() {
        if (this.layerSymbol) {
            this.polygonSymbol = this.layerSymbol as __esri.SimpleFillSymbol;
            this.symbolColor = `rgba(${this.polygonSymbol.color.toRgba()})`;
            this.originalColor = this.symbolColor;
            this.fillStyle = this.polygonSymbol.style;
            if (this.polygonSymbol.outline) {
                this.outlineColor = `rgba(${this.polygonSymbol.outline.color.toRgba()})`;
                this.originalOutlineColor = this.outlineColor;
                this.outlineStyle = this.polygonSymbol.outline.style;
                this.outlineWidth = this.polygonSymbol.outline.width;
            }
        }
    }

    @Input()
    public applyChange = () => {
        this.polygonSymbol.color = Color.fromRgb(this.symbolColor);
        this.polygonSymbol.style = this.fillStyle;
        if (this.polygonSymbol.outline) {
            this.polygonSymbol.outline.width = this.outlineWidth;
            this.polygonSymbol.outline.style = this.outlineStyle;
            this.polygonSymbol.outline.color = Color.fromRgb(this.outlineColor);
        }
        window.dispatchEvent(new CustomEvent<string>('symbolChange', { detail: this.uniqueLayerId }));
    }
}
